var exports = {
  "kL": "MobileBottomNavSkeleton.module__container___dzFJTj",
  "pc": "MobileBottomNavSkeleton.module__navItem___dzFJTj",
  "hk": "MobileBottomNavSkeleton.module__navItemLabel___dzFJTj",
};

module.exports = exports;
